import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";

const DEF = { enabled: true, hours_before: 2 };
const HOURS = [1, 2, 3, 6, 12, 24];

export const BriefEmail = () => {
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/rcc/li/settings").then((r) => setV({ ...DEF, ...(r.data?.brief_email || {}) })).catch(() => setV(DEF)); }, []);
  if (!v) return null;
  const save = async () => {
    setBusy(true);
    try { await api.put("/admin/rcc/li/settings", { brief_email: v }); toast.success(v.enabled ? `Briefs will be emailed ${v.hours_before}h before each call.` : "Brief emails turned off."); }
    catch (e) { toast.error(e.response?.status === 404 ? "Saving brief email settings isn't live on the backend yet (spec §36.5)." : errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-[#27272A] bg-[#0f0f12] p-3 text-sm text-zinc-200" data-testid="li-brief-email">
      <FileText className="h-4 w-4 text-[#D4AF37]" />Call prep brief email
      <Switch checked={v.enabled} onCheckedChange={(enabled) => setV({ ...v, enabled })} data-testid="li-brief-email-toggle" />
      <select value={v.hours_before} disabled={!v.enabled} onChange={(e) => setV({ ...v, hours_before: Number(e.target.value) })} className="h-8 rounded-md border border-[#27272A] bg-[#121215] px-2 text-xs text-zinc-200 disabled:opacity-40" data-testid="li-brief-email-hours">{HOURS.map((h) => <option key={h} value={h}>{h}h before the call</option>)}</select>
      <Button size="sm" onClick={save} disabled={busy} className="ml-auto h-8 bg-[#D4AF37] text-black" data-testid="li-brief-email-save">Save</Button>
      <p className="basis-full text-[11px] text-zinc-500">A one-page brief on the hiring manager and their company is written as soon as a call is booked, and emailed to you before it starts.</p>
    </div>
  );
};
